import { defineMessage } from "react-intl";
import type { FigureMetadata } from "../components/figure";

export const metadata: FigureMetadata = {
  id: "ODA_GDP",
  title: defineMessage({
    id: "fig.finance.aid.ODA_GDP.title",
    defaultMessage: `Only a few countries spend more than 0.7% of their income on aid – and even fewer might do so in the future`,
  }),
  caption: defineMessage({
    id: "fig.finance.aid.ODA_GDP.caption",
    defaultMessage: ``,
  }),
  source: defineMessage({
    id: "fig.finance.aid.ODA_GDP.source",
    defaultMessage: `GEM Report team analysis based on OECD CRS`,
  }),
};
